// extracted by mini-css-extract-plugin
export default {"connectWallet":"ConnectWallet_connectWallet__B+wMT","galaxy":"ConnectWallet_galaxy__0VM+a"};